// extracted by mini-css-extract-plugin
export var arrow = "_38-6";
export var changeItem = "_38-3";
export var changesHeader = "_38-1";
export var changesList = "_38-2";
export var container = "_38-0";
export var pathLabel = "_38-4";
export var value = "_38-7";
export var valuesContainer = "_38-5";